// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AppController from "./app_controller"
application.register("app", AppController)

import CookiesController from "./cookies_controller"
application.register("cookies", CookiesController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HeroController from "./hero_controller"
application.register("hero", HeroController)

import TwilioController from "./twilio_controller"
application.register("twilio", TwilioController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ScrollerController from "./scroller_controller"
application.register("scroller", ScrollerController)

import FeatureTabsController from "./feature_tabs_controller"
application.register("feature-tabs", FeatureTabsController)

import EnquiryController from "./enquiry_controller"
application.register("enquiry", EnquiryController)

import ReelController from "./reel_controller"
application.register("reel", ReelController)
